import { render } from "./SettlementSummary.vue?vue&type=template&id=079bf13b&scoped=true"
import script from "./SettlementSummary.vue?vue&type=script&lang=js"
export * from "./SettlementSummary.vue?vue&type=script&lang=js"

import "./SettlementSummary.vue?vue&type=style&index=0&id=079bf13b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079bf13b"]])

export default __exports__